var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"scale"}},[(_vm.props.loading)?_c('v-layout',{staticClass:"mt-16",attrs:{"justify-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }